var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotateAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5303 1.46967C13.8232 1.76256 13.8232 2.23744 13.5303 2.53033L11.8107 4.25H13.2727C18.4881 4.25 22.75 8.37283 22.75 13.5C22.75 18.6272 18.4881 22.75 13.2727 22.75C12.8585 22.75 12.5227 22.4142 12.5227 22C12.5227 21.5858 12.8585 21.25 13.2727 21.25C17.6972 21.25 21.25 17.7617 21.25 13.5C21.25 9.23833 17.6972 5.75 13.2727 5.75H11.8107L13.5303 7.46967C13.8232 7.76256 13.8232 8.23744 13.5303 8.53033C13.2374 8.82322 12.7626 8.82322 12.4697 8.53033L9.46967 5.53033C9.39776 5.45842 9.34351 5.37555 9.30691 5.28709C9.27024 5.19866 9.25 5.10169 9.25 5C9.25 4.89831 9.27024 4.80134 9.30691 4.71291C9.34351 4.62445 9.39776 4.54158 9.46967 4.46967L12.4697 1.46967C12.7626 1.17678 13.2374 1.17678 13.5303 1.46967Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.60994 13.0275C1.79669 13.8407 1.79669 15.1593 2.60994 15.9725L7.02748 20.3901C7.84073 21.2033 9.15927 21.2033 9.97252 20.3901L14.3901 15.9725C15.2033 15.1593 15.2033 13.8407 14.3901 13.0275L9.97252 8.60994C9.15927 7.79669 7.84073 7.79669 7.02748 8.60994L2.60994 13.0275Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateAlt);
export default __webpack_public_path__ + "static/media/rotate-alt.f6e2fe5dcea73c28c2e741aa57578afc.svg";
export { ForwardRef as ReactComponent };